import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';

export const UPLOAD_CONS = {
  SMALL_FILE_SIZE_LIMIT: 10*1024*1024, //bytes
  MAX_CHUNK_SIZE_IN_MB: 20, //megabytes
  MIN_CHUNK_SIZE_IN_MB: 2, //megabytes
  ESTIMATED_SMF_TIME_CALC_DELAY: 2000, //milliseconds
  ESTIMATED_LGF_TIME_CALC_DELAY:4000, //milliseconds
  CHUNK_READ_TIME_CAL_DELAY:1000, // milliseconds
  CHECKSUM_CALC_CHUNK_SIZE: 1024*1024, //bytes
  FIRST_CHUNK_SIZE: 2*1024*1024, //byets,
  AUTORETRY_REQ_TIME_DELAY:5000, //milliseconds,
  AUTORETRY_REQ_COUNT:5,
  AUTORETRY_REQ_COUNT_FOR_FOLDER_UPLOAD:2,
  PRGBAR_COLPSE_DELAY: 15000, //miiliseconds
  PRGBAR_CLOSE_DELAY:3000,
  ERR: {
    DRAGNDRP_NOTSUPPORT_ERR: "We do not support the feature for this browser. Please upgrade your browser to the latest version",
    FILE_READ_ERR: "Error in Reading File.",
    FOLDER_EXISTS: "Folder(s) already exist.",
    FOLDER_ERR_PRGBAR: "Already exists.",
    INSUFF_QUOTA_ERR_FOLDER_UPLD: 'You don’t have enough space to complete this action!',
    GENERIC_ERR: "Something went wrong. Please try again later.",
    retryErrorList:  ["TEJUF0403", "TEJUF0404", "TEJUF0405", "TEJUF0406", "TEJUF0407",
    "TEJUF0408", "TEJUF0410", "TEJUF0411", "TEJUF0412", "TEJUF0414", "TEJUF0415", "TEJUF0416", "TEJUF0417",
    "TEJUF0418", "TEJUF0419", "TEJUF0423", "TEJUF0424", "TEJUF0425", "TEJUF0426", "TEJUF0427", "TEJUF0442", "TEJUF0443", "TEJRF0500",
    "TEJRF0501", "TEJRF0502", "TEJRF0503", "TEJRF0504", 500, 501, 502, 503, 504, "TEJRF0415"
    ],
    SERVER_ERR: { 
      "5XX" : [500, 501, 502, 503, 504],
      "4XX": []
    },
    ERR_MSG_MAP: {
      "TEJUM0409": "You don't have enough space to complete this action!",
      "TEJGA0401":"Your session has expired! Redirecting you to the home screen.",
      "BINVS0003":"You are no longer a part of this album",
      "TEJUF0437":"You are no longer a part of that album",
      "TEJUF0429": "File Already Exists in Album.",
      "TEJQU1009": "Your storage is full. You can't perform this action.",
      "TEJSO1009": "Owner storage is full. Please request the owner to empty some space and try again later.",
      "TEJUF0422": "Your storage is full. You can't perform this action.",
      "5XX": "Something went wrong. Please try again later.",
    },
    CANCEL_ALL_UPLOADS:"Upload is canceled and new files won't be uploaded."
  },
  FILE_FORMATS: {
    VIDEO :[".3gp", ".3gpp", ".3gpp2", ".m3u8", ".avi", ".mov", ".mp4", ".m4v", ".mpg", ".mkv", ".mpeg", ".vob", ".flv", ".mts", ".m2t", ".ts", ".dv", ".divx", ".webm"],
    AUDIO : [".wav", ".mp3", ".m4a", ".Flac", ".3gp", ".mp4", ".wmv", ".mid", ".imelody", ".ota", ".rtx", ".xmf", ".aiff", ".ogg", ".m4r", ".wma", ".ts"],
    IMG :[".jpeg", ".bmp", ".gif", ".png", ".jp2", ".webp", ".pbm", ".jpg", ".tiff", ".hdr", ".miff", ".tga", ".bpg", ".rgb", ".JPEG 2000", ".exif"],
    NOTALLOWED: [ 'desktop.ini', 'thumbs.db', 'ehthumbs.db', '.ds_store', '.spotlight-v100', '.trashes', '.appledouble', '.apdisk', '._*', '__macosx' ]

  },
  SERVICE_URL : {
    ALBUMS_SMALL_FILE_UPLOAD : ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardUploadURL"] + ENV_CONFIG.commonUrls["singleFileUpload"],
    SMALL_FILE_UPLOAD: ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["uploadURL"] + ENV_CONFIG.commonUrls["singleFileUpload"],
    CHUNK_UPLOAD_INITIATE: ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["uploadURL"] + ENV_CONFIG.commonUrls["upload"],
    CHUNK_UPLOAD : ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["uploadURL"] + ENV_CONFIG.commonUrls["chunkUpload"],
    CREATE_FOLDER: ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["createFolder"],
    CREATE_PRIVATE_FOLDER: ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["createPrivateFolder"]
  }
}
